module.exports = __webpack_public_path__ + "front/img/b26_5.4adf294d.jpg";